import { BreadcrumbItem, selectedProjectType } from './../../../common/sub-header/sub-header.component';
import { HeaderTitle } from './../../../common/header-title/header-title.model';
import { Subscription } from 'rxjs';
import { HeaderTitleService } from '@app/shared/common/header-title/header-title.service';
import { Injector, Component, OnInit, Inject, ChangeDetectorRef, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { ThemesLayoutBaseComponent } from '@app/shared/layout/themes/themes-layout-base.component';
import { UrlHelper } from '@shared/helpers/UrlHelper';
import { DOCUMENT } from '@angular/common';
import { OffcanvasOptions } from '@metronic/app/core/_base/layout/directives/offcanvas.directive';
import { AppConsts } from '@shared/AppConsts';
import { ToggleOptions } from '@metronic/app/core/_base/layout/directives/toggle.directive';
import { DateTimeService } from '@app/shared/common/timing/date-time.service';
import { Router } from '@angular/router';
import {
    ClientContactCreateOrEditDto,
    ClientCreateOrEditDto, ClientType,
    MyProfileOutput,
    ProfileServiceProxy, ProjectType, UserServiceProxy
} from '../../../../../shared/service-proxies/service-proxies';
import { AbpSessionService } from 'abp-ng2-module';
import { ProjectsNewComponent } from '@app/main/projects-new/projects-new.component';
import { ClientNewComponent } from '@app/main/client-new/client-new.component';
import { ClientDropServiceService } from './client-drop-service.service';
import { ClientNameService } from './client-name.service';
import { ProjectDropServiceService } from './project-drop-service.service';
import { DefaultLayoutService } from './default-layout.service';
import { ProductsAndServicesTabsNewService } from '@app/main/products-and-services-new/products-and-services-tabs-new.service';
import { finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppNavigationService } from '@app/shared/layout/nav/app-navigation.service';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { AppRoutes } from '@app/shared/routes/app-routes';
@Component({
    standalone: false,
    templateUrl: './default-layout.component.html',
    selector: 'default-layout',
    animations: [appModuleAnimation()],

})
export class DefaultLayoutComponent extends ThemesLayoutBaseComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(ProjectsNewComponent) projectChild: ProjectsNewComponent;
    @ViewChild(ClientNewComponent) clientChild: ClientNewComponent;
    clientType = ClientType;

    clientSelectedHeading = "ActiveClients";
    uparrow = true;
    clientId: number;
    option: number;
    isProfileData: boolean = false;
    isAsideCollapsed: boolean = false;

    projectSelectedHeading = "ActiveProjects";

    projType: number;
    newProjTabs: number[] = [];

    clientData: ClientCreateOrEditDto = new ClientCreateOrEditDto();
    clientContactData: ClientContactCreateOrEditDto[] = [];
    primaryContactList: ClientContactCreateOrEditDto[] = [];
    secondaryContactList: ClientContactCreateOrEditDto[] = [];
    breadcrumbs: BreadcrumbItem[];
    selectedProjectTypes: selectedProjectType[];
    pageTitleSub: Subscription;

    productServiceSelectionTypeValue: string = 'Products';
    productServiceSelectedTab = 1;
    productSelectionDropdownValue = 'ActiveProducts';
    serviceSelectionDropdownValue = 'ActiveServices';
    userSelectedType = 'activeUsers';
    dashboardSelectedType = 'MyDashboard';
    textForClass: string = 'la-angle-down';

    menuCanvasOptions: OffcanvasOptions = {
        baseClass: 'aside',
        overlay: true,
        closeBy: 'kt_aside_close_btn',
        toggleBy: 'kt_aside_mobile_toggle'
    };

    userMenuToggleOptions: ToggleOptions = {
        target: this.document.body,
        targetState: 'topbar-mobile-on',
        toggleState: 'active'
    };
    isClient = false;
    hideHeaderBreadcrumbs = false;
    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;
    isLoginForFirstTime: boolean = false;
    checkLogin: string;
    isVisible: boolean = true;
    tabIndexFinal: any;
    tabIndex: any;
    clientName: any;
    routerLink: any;
    event = this._clientNameService.getCardList();
    myProfileRole: any;
    isCheckProfile: boolean = false;
    isuserDetailsPage: boolean = false;
    private readonly productServiceResponseHandler = () => this.getProductServiceResponse();
    private readonly checkFirstLoginHandler = () => this.checkLoginForUserToHide();
    private readonly checkLoginSuccessHandler = () => this.userQuickStartDetailsCheck();

    projectType: ProjectType = ProjectType.AllProjects;
    FirstTimeLoginCheck: string;

    webAppVersion: string;

    constructor(
        injector: Injector,
        @Inject(DOCUMENT) private document: Document,
        _dateTimeService: DateTimeService,
        private _clientNameService: ClientNameService,
        private _client_drop_service: ClientDropServiceService,
        private _projectDropService: ProjectDropServiceService,
        private _userService: UserServiceProxy,
        private _profileService: ProfileServiceProxy,
        private _abpSessionServiceProxy: AbpSessionService,
        private _appSession: AppSessionService,
        private headerTitleService: HeaderTitleService,
        private cdRef: ChangeDetectorRef,
        private router: Router,
        public _defaultLayoutService: DefaultLayoutService,
        private _productsAndServicesTabsNewService: ProductsAndServicesTabsNewService,
        private _appNavigationService: AppNavigationService
    ) {
        super(injector, _dateTimeService);

    }

    getProductServiceResponse() {

        this._productsAndServicesTabsNewService.showProductServiceType.subscribe((res: any) => {

            this.productServiceSelectionType(res);

        })
    }

    ngOnInit() {
        this.webAppVersion = this._appSession.webAppVersion;

        abp.event.on('getProductServiceResponse', this.productServiceResponseHandler);
        const myProfileDataisChanged = JSON.parse(localStorage.getItem('MyProfileDataSaved'));
        const cachedProfileData = myProfileDataisChanged ? null : this.getCachedProfileData();

        if (cachedProfileData) {
            this.afterMyProfileInfoInitialize(cachedProfileData);
        } else {
            this._profileService.myProfileInfo().subscribe(res => {
                AppConsts.myProfileInfo = res;
                localStorage.setItem('MyProfileDataSaved', 'false');
                this.afterMyProfileInfoInitialize(res);
            });
        }

        abp.event.on('CheckFirstLoginofUser', this.checkFirstLoginHandler);

        this.tabIndexFinal = this._clientNameService.getCardList();
        abp.event.on('checkLoginSuccessFordefault', this.checkLoginSuccessHandler);
        this.isLoginForFirstTime = JSON.parse(localStorage.getItem('checkLoginSuccess'));

        this.isCheckForClientUser();
        this.hideHeaderBreadcrumbs = this._appNavigationService.shouldHideHeaderBreadcrumbs();

        this.installationMode = UrlHelper.isInstallUrl(location.href);
        this.pageTitleSub = this.headerTitleService.getPageTitle().subscribe((res: HeaderTitle) => {
            if (this.router.url.includes(AppRoutes.admin.inviteUserprofile)) {
                this.isuserDetailsPage = true;
            }
            if (this.router.url.includes(AppRoutes.admin.inviteUser)) {
                this.isuserDetailsPage = true;
            }

            this.breadcrumbs = res.breadcrumbs;

            // Sync dropdown label when a dashboard sub-tab breadcrumb is set by components
            if (res.breadcrumbs && res.breadcrumbs.length >= 2 && res.breadcrumbs[0]?.text === 'Dashboard') {
                this.dashboardSelectedType = res.breadcrumbs[1].text;
            }

            this.cdRef.markForCheck();
        });

    }

    ngAfterViewInit(): void {
        if(!AppConsts.initialLoadSideBar) { AppConsts.initialLoadSideBar = true;
            if (this.document.body.classList.contains('aside-minimize')) {
                this.toggleLeftAside();
            }
        }
        this.isAsideCollapsed = this.document.body.classList.contains('aside-minimize');
    }

    get showAsideCollapseToggle(): boolean {
        const menu = this.currentTheme && this.currentTheme.baseSettings && this.currentTheme.baseSettings.menu;
        const theme = this.currentTheme && this.currentTheme.baseSettings && this.currentTheme.baseSettings.theme;
        return !!(menu && menu.allowAsideMinimizing) || theme === 'theme12' || theme === 'theme13';
    }

    toggleLeftAside(): void {
        this.document.body.classList.toggle('aside-minimize');
        localStorage.setItem('aside-minimize-isSet', this.document.body.classList.contains('aside-minimize').toString());
        this.isAsideCollapsed = this.document.body.classList.contains('aside-minimize');
        this.triggerAsideToggleClickEvent();
    }

    triggerAsideToggleClickEvent(): void {
        abp.event.trigger('app.kt_aside_toggler.onClick');
        abp.event.trigger('isSideBarToggle', this.document.body.classList.contains('aside-minimize'));
    }

    checkLoginForUserToHide() {
        this.FirstTimeLoginCheck = JSON.parse(localStorage.getItem('FirstTimeCheck'));

    }

    private getCachedProfileData(): MyProfileOutput | null {
        if (AppConsts.myProfileInfo) {
            return AppConsts.myProfileInfo;
        }

        const loggedUserData = localStorage.getItem('MyProfileData');
        if (!loggedUserData) {
            return null;
        }

        try {
            return JSON.parse(loggedUserData);
        } catch {
            return null;
        }
    }

    afterMyProfileInfoInitialize(res) {
        this.isProfileData = true;
        localStorage.setItem('MyProfileData', JSON.stringify(res));
        this.myProfileRole = res.roleName;
        localStorage.setItem('MyProfileDetails', JSON.stringify(res));
        if (this.myProfileRole == 'Employee' || this.myProfileRole == 'Client') {
            this.isCheckProfile = true;
        }
        else {
            this.isCheckProfile = false;
        }
    }

    dashboardChange() {
        let value = 1;
        this._defaultLayoutService.showDashboardType.next(value);
        abp.event.trigger('getDashboardTabChangeResponse');

    }

    userQuickStartDetailsCheck() {
        this.isLoginForFirstTime = JSON.parse(localStorage.getItem('checkLoginSuccess'));
        this.userQuickStartforTopbarDownload();

    }

    onClick(client: string) {
        if (client == this.l("ActiveClients")) {

            this.router.navigate([AppRoutes.clients]);
        }
        if (client == this.l("ArchivedClients")) {
            this.router.navigate([AppRoutes.clients]);
        }
        if (client == this.l("ActiveProducts")) {
            this.router.navigate([AppRoutes.productsAndServices])
        }
        if (client == this.l("ActiveServices")) {
            this.router.navigate([AppRoutes.productsAndServices])
        }
        if (client == this.l("ActiveProjects")) {

            this.router.navigate([AppRoutes.projects]);
        }
        if (client == this.l("ArchivedProjects")) {

            this.router.navigate([AppRoutes.projects]);
        }
        if (client == this.l("activeUsers")) {
            this.router.navigate([AppRoutes.admin.users]);
        }

    }

    userQuickStartforTopbarDownload() {
        abp.event.trigger('checkLoginForTopbardownload');
        abp.event.trigger('checkLoginForTopbarSetting');
    }

    goToBreadcrumb(breadcrumb: BreadcrumbItem): void {
        if (!breadcrumb.routerLink) {
            return;
        }
        if (breadcrumb.navigationExtras) {
            this.router.navigate([breadcrumb.routerLink], breadcrumb.navigationExtras);
        }

        else {
            this.router.navigate([breadcrumb.routerLink]);
        }
    }

    formatBreadcrumbText(text: string): string {
        if (!text) {
            return '';
        }

        return (this.l(text) || text || '').replace('|', '').trim();
    }

    /**
     * Dashboard uses a header dropdown for sub-tabs, so hide duplicate sub-tab crumbs.
     */
    shouldShowBreadcrumbItem(index: number): boolean {
        const crumbs = this.breadcrumbs;
        if (!crumbs?.length || index < 0 || index >= crumbs.length) {
            return false;
        }

        const first = (crumbs[0]?.text || '').replace('|', '').trim();
        if (first === 'Dashboard' && index > 0) {
            return false;
        }

        return true;
    }

    ngOnDestroy() {
        this.pageTitleSub?.unsubscribe();
        abp.event.off('getProductServiceResponse', this.productServiceResponseHandler);
        abp.event.off('CheckFirstLoginofUser', this.checkFirstLoginHandler);
        abp.event.off('checkLoginSuccessFordefault', this.checkLoginSuccessHandler);
    }
    selectedTab(value: any) {

        this._client_drop_service.showClientType.next(value);

        abp.event.trigger('getClientResponse');

        if (value === 1) {

            this.clientSelectedHeading = 'ActiveClients';

        }

        if (value === 2) {

            this.clientSelectedHeading = 'ArchivedClients';

        }

        if (value === 3) {

            this.clientSelectedHeading = 'DeletedClients';

        }

    }

    selectedProTab(value: any) {

        this._projectDropService.showProjectType.next(value);

        abp.event.trigger('getProjectResponse');

        if (value === 1) {

            this.clientSelectedHeading = 'ActiveProjects';

        }

        if (value === 2) {

            this.clientSelectedHeading = 'ArchivedProjects';

        }

        if (value === 3) {

            this.clientSelectedHeading = 'DeletedProjects';

        }

    }

    selectedProjectType = 'Active';
    onOpenChange(data: boolean): void {
        this.textForClass = data ? 'la-angle-up' : 'la-angle-down';
    }

    //** Check for Is login PErson is client or not
    isCheckForClientUser() {
        if (this._abpSessionServiceProxy.tenantId == null)
            return;
        if (this._abpSessionServiceProxy.tenantId == undefined)
            return;

        if (AppConsts.isCheckClient !== undefined) {
            this.isClient = AppConsts.isCheckClient;
        } else {
            this._userService.isCheckClient(this._abpSessionServiceProxy.userId, this._abpSessionServiceProxy.tenantId).subscribe(x => {
                this.isClient = x;
                AppConsts.isCheckClient = x;
            });

        }
    }

    selectedTabForClient(value: number) {

        this._defaultLayoutService.selectedTabForClient(value);
        this.router.navigate([AppRoutes.clients], { queryParams: { id: value } });
    }

    selectedTabForProject(value: number) {

        this._defaultLayoutService.selectedTabForProject(value);
        this.router.navigate([AppRoutes.projects], { queryParams: { id: value } });

    }

    productServiceSelectionType(value: number) {

        this.productServiceSelectedTab == value;
        if (value === 1) {
            this.productServiceSelectionTypeValue = 'Products';
        }
        else {
            this.productServiceSelectionTypeValue = 'Services';
        }
    }

    productSelectionType(value: number) {
        if (!value || value < 1 || value > 3) {
            return;
        }

        this._defaultLayoutService.selectedTabForProduct(value);
        this._defaultLayoutService.showProductType.next(value);
        abp.event.trigger('getProductResponse');
        this.router.navigate([AppRoutes.productsAndServices], { queryParams: { id: value } });

        if (value === 1) {
            this.productSelectionDropdownValue = 'ActiveProducts';
        } else if (value === 2) {
            this.productSelectionDropdownValue = 'ArchivedProducts';
        } else {
            this.productSelectionDropdownValue = 'DeletedProducts';
        }
    }

    serviceSelectionType(value: number) {
        if (!value || value < 1 || value > 3) {
            return;
        }

        this._defaultLayoutService.selectedTabForService(value);
        this._defaultLayoutService.showServiceType.next(value);
        abp.event.trigger('getServiceResponse');
        this.router.navigate([AppRoutes.productsAndServices], { queryParams: { id: value } });

        if (value === 1) {
            this.serviceSelectionDropdownValue = 'ActiveServices';
        } else if (value === 2) {
            this.serviceSelectionDropdownValue = 'ArchivedServices';
        } else {
            this.serviceSelectionDropdownValue = 'DeletedServices';
        }
    }

    selectedUserTab(value: number) {
        return;
        this._defaultLayoutService.selectedUserTab(value);
        this.router.navigate([AppRoutes.admin.users], { queryParams: { id: value } });

    }

    selectedTabDashboard(value: number) {
        this.uparrow = true;
        /*assigning value to the functions*/
        if (value == 0) {
            this.dashboardSelectedType = 'MyDashboard';
        } else if (value == 1) {
            this.dashboardSelectedType = 'TeamDashboard';
 }else if (value == 2) {
            this.dashboardSelectedType = 'ResourceBookingDashboard';

        }
        abp.event.trigger('selectedTabAdminDashboard', value);

    }

}

